import { Box } from '@mui/joy';

import { CorporatePartUom } from 'corporate/components/CorporatePartUom';
import { ICorporatePart } from 'corporate/types';

import { PartDetailsTab } from '../enums';
import { usePartDetailsScrollToFocus } from '../hooks';

interface IProps {
  corporatePart?: Partial<ICorporatePart>;
  partNumber: string;
  manufacturerId: number;
  enabled?: boolean;
  fullWidth?: boolean;
  isLoading?: boolean;
}

const MIN_ROWS_FOR_FOCUS_TRIGGER = 3;

export const UoM = (props: IProps) => {
  const { panelScrollAnchorRef, onBodyScroll } = usePartDetailsScrollToFocus(PartDetailsTab.UOM, {
    minRowsForTrigger: MIN_ROWS_FOR_FOCUS_TRIGGER,
  });

  return (
    <Box ref={panelScrollAnchorRef} sx={{ display: 'contents' }}>
      <CorporatePartUom {...props} onBodyScroll={onBodyScroll} />
    </Box>
  );
};
